export default Object.freeze({
  STATUS: {
    DRAFT: 0,
    PUBLISH: 1,
  },
  TYPES: {
    HOMEPAGE: 1,
    LISTICLE: 2,
    BOOK_LISTICLE: 3,
    LONG_FORM: 4,
    INTERVIEW: 5,
    SLIDESHOW: 6,
    VIDEO: 7,
    BOOK_EXCERPT: 8,
    PAGE: 9,
    GENERAL: 10,
    FUNNEL: 11,
    DEALS: 12,
    LANDING_DEALS: 13,
    CATEGORY_FUNNEL: 14,
    GIVEAWAY_PAGE: 16,
    TELL_A_FRIEND_PAGE: 15,
    EBB_HOMEPAGE: 17,
    INTEREST_PAGE: 18,
    YOUNG_BOOK_READER: 19,
    KINDLE_UNLIMITED_DEALS: 20,
  },
});
